export default __webpack_public_path__ + "static/media/star.46192e5b.svg";